<span
  #textElement
  [ngClass]="cutTextClass + ' cut-text'"
  [pTooltip]="isTruncated ? text : undefined"
  [ngStyle]="{
    maxWidth: maxWidth + 'px',
}">
  {{text}}
</span>
